const i = {
  id: "ArizonaPick4",
  name: "Pick 4",
  style: {
    colorPrimary: "#124A85"
  }
};
export {
  i as default
};
